import { useSession } from 'next-auth/react';
import { hasRole as hasRoleUtil } from './utils';
import type { Roles } from '@lib/domain/auth';

export const useHasRole = (role: Roles): boolean => {
  const { data: session } = useSession();
  return hasRoleUtil(role, session?.user?.roles) ?? false;
};
